import React from 'react';
import { motion} from 'framer-motion';
import pmsImg from "../assets/legacy.png";
import banner2 from '../assets/banner2.png';
import familyImg from '../assets/legacy-fam.png';
import heirImg from '../assets/succession.png';
import recoveryImg from '../assets/unclaimed.png';
import willImg from '../assets/legacy-will.png';
import conciergeImg from '../assets/pt.png';
import demiseImg from '../assets/coh.png';
import { 
  Scale, 
  ShieldCheck, 
  FileCheck, 
  Home, 
  Search, 
  UserPlus 
} from 'lucide-react';
const Legacy = () => {



  const services = [
    {
      id: "01",
      image: willImg,
      icon: <Scale className="text-red-600" size={24} />,
      title: "Will Creation",
      text: "A Will ensures your wealth and assets are distributed as per your wishes after your demise. It defines beneficiaries, executors, and witnesses and prevents disputes or delays under intestate succession laws.",
      usp: "A Will takes effect only after death and focuses on asset distribution, not management. It’s the foundation of every legacy plan.",
      tag: "The Foundation"
    },
    {
      id: "02",
      image: familyImg,
      icon: <ShieldCheck className="text-red-600" size={24} />,
      title: "Family Trust",
      text: "A Family Trust allows you to manage, protect, and pass on assets during your lifetime and beyond. It ensures privacy, protects wealth from disputes, and simplifies business or family succession.age, protect, and pass on assets during your lifetime and beyond. ",
      usp: "A Trust operates during life, unlike a Will, and offers asset protection and continuity.",
      tag: "Live Management"
    },
    {
      id: "03",
      image: heirImg,
      icon: <FileCheck className="text-red-600" size={24} />,
      title: "Succession / Legal Heir Certificate",
      text: "These certificates are legal proofs of heirship required to claim or transfer assets when a person passes away. Succession Certificates (issued by courts) cover movable assets, while Legal Heir Certificates (issued by local authorities) confirm family relationships. proofs of heirship required to claim or transfer assets. ",
      usp: "They don’t define distribution—they only establish the right to claim.",
      tag: "Legal Proof"
    },
    {
      id: "04",
      image: conciergeImg,
      icon: <Home className="text-red-600" size={24} />,
      title: "Property Transfer & Claims",
      text: "After death, property ownership changes hands through Probate (if there’s a Will) or via Succession Certificates (if there isn’t). DreamLadder assists families in completing mutation, documentation, and registration smoothly. ",
      usp: "It focuses solely on transferring ownership of immovable assets.",
    },
    {
      id: "05",
      image: recoveryImg,
      icon: <Search className="text-red-600" size={24} />,
      title: "Unclaimed Asset Recovery",
      text: "Thousands of crores lie unclaimed in banks, mutual funds, and insurance policies due to missing paperwork or lack of awareness. We help families trace and recover such funds through RBI’s DEAF, IEPF, and other official channels.",
      usp: "It’s about reclaiming forgotten wealth, not planning new inheritance.",
      tag: "Wealth Recovery"
    },
    {
      id: "06",
      image: demiseImg,
      icon: <UserPlus className="text-red-600" size={24} />,
      title: "All Post-Demise Services",
      text: "Our Post-Demise Services cover every stage after a person’s passing—document collection, Will execution, property transfers, unclaimed asset recovery, and tax filings.",
      usp: "It’s a complete, end-to-end solution that ensures your family’s financial transition is smooth, compliant, and stress-free.",
      tag: "Full Concierge"
    }
  ];
  return (
    <div className="bg-white min-h-screen">
      {/* SECTION 1: WHAT IT IS (Image Left, Text Right) */}
         {/* SECTION 1: WHAT IT IS (Image Left, Text Right) */}
          <section
  className="relative py-16 md:py-24 text-center overflow-hidden"
  style={{
    backgroundImage: `url(${banner2})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  


  <h3 className="relative z-10 font-syne text-[24px] md:text-[32px] text-slate-900 tracking-tight font-medium">
          Legacy and Estate Planning
        </h3>
  <div
    className="pointer-events-none absolute bottom-0 left-0 w-full h-[120px]"
    style={{
      background:
        "linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0.35) 40%, rgba(255,255,255,0.7) 70%, rgba(255,255,255,1) 100%)",
    }}
  />
</section>



      

<section className="relative min-h-[85vh] pt-20  overflow-hidden bg-white -mb-32">

  {/* Background Decor - Restored width for symmetry */}
  <div className="absolute top-0 right-0 w-1/3 h-full bg-slate-50 -z-10 hidden lg:block" />

  <div className="max-w-7xl mx-auto px-6 lg:px-24">
   <div className="flex flex-col lg:flex-row items-start justify-between gap-15">

      
      {/* LEFT SIDE: CONTENT */}
     <motion.div
  initial={{ opacity: 0, y: 20 }}
  animate={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.6 }}
  className="w-full lg:w-3/5"
>
  <h3 className="ext-[24px] md:text-[40px] font-[450] text-gray-900 tracking-tight mb-3">
    Building a Complete Legacy Plan
  </h3>

  <div className="space-y-3 max-w-xl">
    <div className="divide-y divide-slate-100">
      {[
        "A Will defines who inherits",
        "A Trust manages and protects wealth",
        "Certificates establish heirship",
        "Property transfers and asset recovery handle execution",
        "Post-demise services ensure closure",
      ].map((text, i) => (
        <p
          key={i}
          className="py-2.5 text-slate-600 text-lg md:text-xl leading-relaxed"
        >
          {text}
        </p>
      ))}
    </div>

    <p className="text-slate-500 text-base md:text-lg font-medium border-l-4 border-red-600 pl-4 py-1.5 mt-4 italic">
      Together, these create a seamless, secure legacy for your family.
    </p>
  </div>
</motion.div>


      {/* RIGHT SIDE: IMAGE */}
     <motion.div
  className="w-full lg:w-1/2 flex justify-end mt-12"
  initial={{ opacity: 0, x: 20 }}
  animate={{ opacity: 1, x: 0 }}
  transition={{ duration: 0.8 }}
>
  <div className="relative w-full max-w-[640px]">
    <img
      src={pmsImg}
      alt="Legacy Planning Overview"
      className="w-full h-auto object-contain"
    />
  </div>
</motion.div>


    </div>
  </div>
</section>






{/* CORE EXPERTISE - DETAILED ALTERNATING SECTIONS */}
<section className="bg-white">
  {services.map((item, idx) => (
    <div 
      key={idx} 
      className={`relative py-12 md:py-16 overflow-hidden ${idx % 2 !== 0 ? 'bg-white' : 'bg-slate-50'}`}
    >
      {/* Background Decor */}
      <div className={`absolute top-0 ${idx % 2 === 0 ? 'right-0' : 'left-0'} w-1/3 h-full bg-slate-100/40 -z-10 hidden lg:block`} />

      <div className="max-w-7xl mx-auto px-6 lg:px-24">
        <div className={`flex flex-col ${idx % 2 === 0 ? 'lg:flex-row-reverse' : 'lg:flex-row'} items-center justify-between gap-8 lg:gap-16`}>
          
          {/* CONTENT SIDE */}
          <motion.div 
            initial={{ opacity: 0, y: 15 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="w-full lg:w-[55%]"
          >
            <div className="flex items-center gap-2 mb-2">
               <span className="text-slate-500 font-syne font-bold uppercase tracking-[0.1em] text-[10px]">
                Expertise <span>0{idx + 1}</span>
              </span>
            </div>
{/*
            <h3 className="font-syne text-[26px] md:text-[36px] text-slate-900 tracking-tight font-medium mb-4 leading-tight">
              {item.title}
            </h3>
            */}
           <h2 className="font-syne text-[24px] md:text-[32px] font-thin text-black/70 mb-2 md:mb-4 leading-[1.1] whitespace-pre-line tracking-tighter"> {item.title}</h2>

            <div className="space-y-4 max-w-xl">
              <p className="text-slate-600 text-lg md:text-xl leading-relaxed">
                {item.text} 
              </p>

              {/* Compact USP Block */}
              <div className="p-4 border-l-[3px] border-red-600 bg-white/60 shadow-sm mt-6">
                <span className="text-[9px] uppercase tracking-widest text-slate-400 font-bold block mb-1">
                  Strategic Significance
                </span>
                <p className="text-slate-700 text-base md:text-md font-medium italic leading-snug">
                  "{item.usp}"
                </p>
              </div>
            </div>
          </motion.div>

          {/* IMAGE SIDE */}
          <motion.div 
            className="w-full lg:w-[40%] flex justify-center lg:justify-end"
            initial={{ opacity: 0, scale: 0.98 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
           <div className="relative w-full max-w-[480px]"> {/* Slightly smaller max-width */}
              <div className="overflow-hidden ">
               <img 
                  src={item.image} // DYNAMIC IMAGE USED HERE
                  alt={item.title} 
                  className="w-full h-auto object-contain  transition-transform duration-700"
                />
              </div>
              {/* Subtle accent border - tightened */}
              <div className="absolute -bottom-3 -right-3 w-16 h-16 border-r-2 border-b-2 border-red-600/20 -z-10"></div>
            </div>
          </motion.div>

        </div>
      </div>
    </div>
  ))}
</section>


    </div>
  );
};

export default Legacy;